/**
 * A calendar date as its day, e.g. "Nov 20, 2026". Due dates come from
 * Salesforce as a date with no time, sent as midnight UTC; read in the
 * viewer's own time zone that is the evening before, so the day is read in
 * UTC, the way the payment-link page does.
 *
 * @param iso - The date, as the API sends it.
 * @returns The formatted day, or "—" when there is none.
 */
export function formatCalendarDate(iso?: string | null): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' });
}
